module.exports = __webpack_public_path__ + "static/media/logo.e08c44e9.jpg";